var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"mr-1",attrs:{"small":"","color":_vm.getColor( _vm.idetapa ),"dark":"","hide-details":""}},[_vm._v(_vm._s(_vm.getTexto( _vm.idetapa ))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }